var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-guide"},[_c('div',{staticClass:"guide-img"}),_vm._v(" "),_c('div',{staticClass:"hint"},[_c('p',[_vm._v("如有好友线下的联系方式，可以直接点击【分享按钮】，发送链接给好友，呼唤归来，组队开黑。")]),_vm._v(" "),_c('div',{staticClass:"u-btn btn-share",on:{"click":_vm.call_share}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ea6590f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/guide.vue
// module id = null
// module chunks = 